import { Component } from "react";
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import LoginInfoColumn from "./LoginInfoColumn";
import LoginForm from "./form";
import Box from "@mui/material/Box";
import GoToOlcaButton from "./buttons/GoToOlcaButton";

export default class extends Component {

  componentDidMount() {
    document.body.classList.add("logins");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("login");
  }

  render() {
    return (
      <Box sx={{height: '100%'}} >
        <Box className="login-box">

          <Box display="flex" justifyContent="center">
            <Grid container spacing={3} sx={{height: '100%', width: '80%', marginTop: '80px'}}>
              <Grid item lg={8} sx={{ display: { xs: 'none', lg: 'flex' }, flexDirection: 'column', justifyContent: 'flex-end'  }}>
                <GoToOlcaButton></GoToOlcaButton>
                <LoginInfoColumn></LoginInfoColumn>
              </Grid>
              <Grid item lg={4} xs={12} md={12} sx={{ display: 'flex' , flexDirection: 'column', justifyContent: 'flex-end'  }}>
                <Box sx={{ display: { lg: 'none' } }}>
                  <GoToOlcaButton></GoToOlcaButton>
                </Box>
                <Card style={{ marginTop: '5px', borderRadius: '20px' }}>
                  <LoginForm></LoginForm>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Box>

      </Box>
    );
  }
}
